module.exports = __webpack_public_path__ + "img/login.213badd1.png";